import { SET_USER_ORGANISATIONS, RESET_USER_TIMELINE } from './Constants'

export function setUserOrganisations(organisations) {
  return { type: SET_USER_ORGANISATIONS, organisations }
}

export function resetUserTimeline() {
  return { type: RESET_USER_TIMELINE }
}
